import { render, staticRenderFns } from "./SavingRecommendationResult.vue?vue&type=template&id=20358700&"
import script from "./SavingRecommendationResult.vue?vue&type=script&lang=js&"
export * from "./SavingRecommendationResult.vue?vue&type=script&lang=js&"
import style0 from "./SavingRecommendationResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports